import Repository from "../Repository";

export default {
  // Fetch user field settings
  getUserFieldSettings: () => {
    return Repository.get('/user-field-settings');
  },
  // Update user field settings
  updateUserFieldSettings: (payload) => {
    return Repository.put('/user-field-settings', payload);
  },
}
